module.exports = __webpack_public_path__ + "static/media/SF-13-A (1).09d0f969.mp3";